import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { limitItems } from 'assets/constants/records.limit';
import { Observable } from 'rxjs';
import { InterfaceArea } from '../models/area.model';
import { InterfaceDepartment } from '../models/department.model';
import { InterfaceIndicator } from '../models/indicator.model';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

  constructor(
    protected firestore: AngularFirestore
  ) { }

  generateId(): string {
    return this.firestore.createId();
  }

  saveDepartment(department: InterfaceDepartment): Promise<any> {
    return this.firestore.collection("departments").doc(department.id).set(department);
  }

  updateDepartment(department: InterfaceDepartment): Promise<any> {
    return this.firestore.collection("departments").doc(department.id).set(department);
  }

  getDepartments(lastItem?: InterfaceDepartment): Observable<any> {
    return this.firestore.collection("departments", (query) => lastItem ? query.limit(limitItems).orderBy("id").startAfter(lastItem) : query.limit(limitItems).orderBy("id")).valueChanges();
  }

  createArea(area: InterfaceArea): Promise<any> {
    return this.firestore.collection("areas").doc(area.id).set(area);
  }

  updateArea(area: InterfaceArea): Promise<any> {
    return this.firestore.collection("areas").doc(area.id).update(area);
  }

  getAreas(departmentId: string): Observable<any> {
    return this.firestore.collection("areas", (query) => query.limit(limitItems).where("departmentId", "==", departmentId)).valueChanges();
  }

  createIndicator(area: InterfaceArea): Promise<any> {
    return this.firestore.collection("indicators").doc(area.id).set(area);
  }

  updateIndicator(indicator: InterfaceIndicator): Promise<any> {
    return this.firestore.collection("indicators").doc(indicator.id).update(indicator);
  }

  getIndicators(areaId: string): Observable<any> {
    return this.firestore.collection("indicators", (query) => query.limit(limitItems).where("areaId", "==", areaId)).valueChanges();
  }

  getActiveIndicators(areaId: string, mondayUnix: number, sundayUnix: number): Observable<any> {
    return this.firestore.collection("indicators", (query) => query.orderBy("createdAt").where("areaId", "==", areaId).limit(200)).valueChanges();
  }
}
